if (!customElements.get('mm-product-modal')) customElements.define('mm-product-modal', class extends customElements.get('product-modal') {
 constructor() {
  super();
  this.viewport = this.querySelector('[role="document"]');
  this.detail = this.querySelector('[data-mm-detail]');
  this.querySelectorAll('[data-mm-step]').forEach(button => button.addEventListener('click', () => this.select(this.current + Number(button.dataset.mmStep))));
  this.detail.addEventListener('click', () => this.setDetail(!this.viewport.hasAttribute('data-detail')));
  this.addEventListener('click', event => {if (event.target === this.viewport || event.target === this.querySelector('[role="dialog"]')) this.hide();});
  this.addEventListener('keydown', event => {
   if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key) || this.viewport.hasAttribute('data-detail')) return;
   event.preventDefault();
   this.select(event.key === 'Home' ? 0 : event.key === 'End' ? this.images.length - 1 : this.current + (event.key === 'ArrowRight' ? 1 : -1));
  });
 }
 show(opener) {
  this.gallery = opener.closest('mm-product-gallery');
  const ids = this.gallery.buttons.map(button => button.dataset.mediaId);
  this.images = [...this.viewport.querySelectorAll('[data-media-id]')].filter(image => ids.includes(image.dataset.mediaId));
  this.current = this.images.findIndex(image => image.dataset.mediaId === opener.dataset.mediaId);
  super.show(opener);
 }
 showActiveMedia() {
  const image = this.images[this.current];
  if (!image.getAttribute('src')) image.src = image.dataset.src;
  this.setDetail(false);
  super.showActiveMedia();
  this.querySelector('[data-mm-status]').textContent = (this.current + 1) + ' / ' + this.images.length;
 }
 select(index) {
  this.current = (index + this.images.length) % this.images.length;
  const originalOpener = this.openedBy;
  this.openedBy = this.gallery.querySelector('.mm-zoom-open[data-media-id="' + this.images[this.current].dataset.mediaId + '"]');
  this.showActiveMedia();
  this.openedBy = originalOpener;
 }
 setDetail(enabled) {
  this.viewport.toggleAttribute('data-detail', enabled);
  this.detail.setAttribute('aria-pressed', String(enabled));
  this.detail.textContent = enabled ? this.detail.dataset.fitLabel : this.detail.dataset.zoomLabel;
  this.viewport.scrollTo(0, 0);
 }
});
document.querySelectorAll('mm-product-gallery').forEach(gallery => {
 let start, moved = false;
 gallery.addEventListener('pointerdown', event => {start = [event.clientX,event.clientY]; moved = false;}, {passive:true});
 gallery.addEventListener('pointermove', event => {if (start && Math.hypot(event.clientX-start[0],event.clientY-start[1]) > 10) moved = true;}, {passive:true});
 gallery.addEventListener('click', event => {if (moved && event.target.closest('.mm-zoom-open')) {event.preventDefault(); event.stopImmediatePropagation();} start = null;}, true);
});
